import React from 'react';
import PredicatesGrid from '../components/Predicates/PredicatesGrid';

const Predicates = () => {
  return <PredicatesGrid />;
};

export default Predicates;
